import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import DarkValueSection from "./components/DarkValueSection";
import SocialProof from "./components/SocialProof";
import CtaSection from "./components/CtaSection";
import BlogPreview from "./components/BlogPreview";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://gtbuyspreadsheet.run";
const logoUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/54d75be42d5913aa14ca64dd22e5d1e3.jpeg";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "GTBuy Spreadsheet",
  url: siteUrl,
  description: "GTBuy Spreadsheet is the structured sourcing system built for modern ecommerce sellers. Compare suppliers, track pricing, and optimize dropshipping workflows with a clean spreadsheet-based tool.",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "GTBuy Spreadsheet",
  url: siteUrl,
  logo: logoUrl,
  description: "GTBuy Spreadsheet provides a structured sourcing methodology for ecommerce sellers — supplier comparison, price tracking, and dropshipping workflow optimization.",
  sameAs: [
    "https://kaspreadsheet.com",
  ],
};

export default function Home() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const scrollTo = searchParams.get("scrollTo");
    if (scrollTo === "guides") {
      setTimeout(() => {
        const el = document.getElementById("shopping-guides");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <DarkValueSection />
        <SocialProof />
        <CtaSection />
        <BlogPreview />
      </main>
      <Footer />
    </div>
  );
}